import React, { useEffect, useState } from 'react';
import { Popover } from 'antd';
import InputSearchSuffixIcon from 'components/InputSearchSuffixIcon';
import colorTheme from 'constants/color';
import shopSelectors from 'services/shop/selectors';
import { ICustomerItemData } from 'services/shop/types/customer';
import styled from 'styled-components';
import { formatPhone } from 'utils/formatPhone';

type Props = {
  value?: ICustomerItemData;
  onChange?: (value: ICustomerItemData) => void;
};

const SelecctCustomer = ({ value, onChange }: Props) => {
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);
  const customers = shopSelectors.data.customers();

  // Function to highlight matching text
  const highlightText = (text: string, searchTerm: string) => {
    if (!searchTerm || !text) return text;

    const regex = new RegExp(`(${searchTerm})`, 'gi');
    const parts = text.split(regex);

    return parts.map((part, index) =>
      regex.test(part) ? <HighlightedText key={index}>{part}</HighlightedText> : part
    );
  };

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const handleClickCustomer = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    customer: ICustomerItemData
  ) => {
    e.stopPropagation();
    setOpen(false);
    onChange?.(customer);
  };

  useEffect(() => {
    if (value) {
      setSearch(value.name);
    }
  }, [value]);

  return (
    <Popover
      placement='bottomLeft'
      arrow={false}
      overlayInnerStyle={{
        padding: 0,
      }}
      content={
        <ContentContainer>
          {customers.map((o) => (
            <div
              key={o.id}
              onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
                handleClickCustomer(e, o)
              }
            >
              <div className={`customer-item ${o.id === value?.id ? 'active' : ''}`}>
                <span>{highlightText(o.name || '', search)}</span>
                {o.phone && (
                  <span className='phone'>{highlightText(formatPhone(o.phone) || '', search)}</span>
                )}
              </div>
            </div>
          ))}
        </ContentContainer>
      }
      trigger='click'
      open={open}
      onOpenChange={handleOpenChange}
    >
      <div style={{ minWidth: '400px' }}>
        <InputSearchSuffixIcon
          value={search}
          onChange={(value) => setSearch(value)}
          placeholder='Search by Customer’s Name/Phone'
        />
      </div>
    </Popover>
  );
};

export default SelecctCustomer;

const ContentContainer = styled.div`
  min-width: 500px;
  max-height: 60vh;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
  .customer-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px;
    cursor: pointer;
    color: #1d2129;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    line-height: 30px;
    text-transform: uppercase;
    .phone {
      font-size: 20px;
      font-weight: 600;
    }
  }
  .customer-item:hover {
    background: ${colorTheme.fill_5};
  }
  .customer-item.active {
    background: ${colorTheme.fill_3};
  }
`;

const HighlightedText = styled.span`
  background-color: red;
  color: white;
  padding: 2px 4px;
  border-radius: 3px;
`;
